import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';

function Ad1RequestHeader(props) {

    return (
        <>
            <Row  >
                <Col>
                    <Button variant="outline-danger" size="sm" onClick={(e) => props.back()} >Back </Button>
                </Col>
            </Row>
            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row className='border-top' >
                <Col>Srno : <b>{props?.viewData?.trad_srno}</b></Col>
                <Col>Transaction Date: <b>{props?.viewData?.trad_valuedate?.substring(0, 8)}</b></Col>
                <Col>Reference Number : <b>{props?.viewData?.trad_refno}</b></Col>
                <Col>Branch : <b>{props?.viewData?.trad_branch + ' : ' + props?.viewData?.entity_name}</b></Col>
            </Row>
            {
                props.viewData?.trad_bankrefno === "" && <>
                    <Row>
                        <Col>
                            Bank Reference : <b>{props.viewData?.trad_bankrefno}</b>
                        </Col>
                    </Row>
                </>
            }
            <Row >
                <Col>Reference : <b>{props?.viewData?.trad_type === "S" ? "Branch" : "Agent"}</b></Col>
                <Col>Agent : {
                    props?.viewData?.trad_agentno * 1 === 0 ? null : <>
                        <b>{props?.viewData?.trad_agentno + ' : ' + props?.viewData?.agent_name + ' ' + props?.viewData?.trad_agentlocation}</b>
                    </>
                }
                </Col>
                <Col>                    &nbsp;                </Col><Col>                    &nbsp;                </Col>
            </Row >
            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row>
                <Col>Remitter Type : <b>{props?.viewData?.trad_remmiter_type === "I" ? "Individual" : "Corporate"}</b></Col>
                <Col>Remitter Name : <b>{props?.viewData?.trad_remitter_name}</b></Col>
                <Col>PAN : <b>{props?.viewData?.trad_remitter_pancard_number}</b></Col>
                <Col>Name on Pan : <b>{props?.viewData?.trad_nameonpan}</b></Col>
            </Row>
            
            {/* <Row > */}
                {/* <Col>Purpose: <b>{props?.viewData?.trad_agentno + ' : ' + props?.viewData?.trad_agentno}</b></Col> */}
                {/* <Col>Serial Number : <b>{props?.viewData?.trad_srno}</b></Col> */}
                {/* <Col>Product : <b>{props?.viewData?.trad_agentno}</b></Col> */}
                {/* <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
            </Row> */}
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row >
                <Col>Currency: <b>{props?.viewData?.trad_currency_name}</b></Col>
                <Col>Quantity: <b>{props?.viewData?.trad_quantity}</b></Col>
                <Col>Sell Rate: <b>{props?.viewData?.trad_sale_rate}</b></Col>
                <Col>Forex INR : <b>{(props?.viewData?.trad_total_forex)}</b> </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>

            <Row >
                <Col>Email : <b>{props?.viewData?.trad_email}</b></Col>
                <Col>Mobile : <b>{props.viewData?.trad_remitter_contactno}</b></Col>
                <Col>Nostro Type : <b>{props?.viewData?.trad_nostrotype}</b></Col>
                <Col>BANK : {
                    props?.viewData?.trad_bank_code &&
                    <>
                        <b>{props?.viewData?.trad_bank_code + ' : ' + props?.viewData?.issuer_name}</b>
                    </>
                }
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            {/* <Row> */}
            {/* <Col>ITR 2 Years: <b>{props?.viewData?.req_itr2year === 1 ? "Yes" : "No"}</b></Col> */}
            {/* <Col>Source of Fund: <b>{props?.viewData?.req_sourceoffund === "S" ? "Self" : "Loan"}</b></Col> */}
            {/* {
                    props?.viewData?.req_sourceoffund === "L" ? <>
                        <Col>Disbursed Institute: <b>{props?.viewData?.req_disbinstname}</b></Col>
                        <Col>Disbursed Amount: <b>{props?.viewData?.req_disbamount}</b></Col>
                    </> : <>
                        <Col>&nbsp;</Col><Col>&nbsp;</Col>
                    </>
                } */}
            {/* </Row> */}

            <Row>
                <Col xs={12}>Remark: <b>{props?.viewData?.trad_rmk}</b></Col>
            </Row>
            <Row>
                {/* <Col xs={12}>Remark: <b>{props?.viewData?.req_rmk1}</b></Col> */}
            </Row>
            <Row>
                {/* <Col xs={12}>Remark: <b>{props?.viewData?.req_rmk2}</b></Col> */}
            </Row>
            <Row className='border-top'>
                <Col>
                    &nbsp;
                </Col>
            </Row >
        </>
    )
}
export default Ad1RequestHeader;